<template>
    <div class="userLevelType" v-html="getTranslation('user-types', 'user_type_' + userLevel)"></div>

</template>
<script>
    export default {
        computed: {
            userLevel() {
                return this.$store.state.cart.userLevel;
            }
        }
    }
</script>
<style>
.userLevelType {
    display: inline;
}
</style>
